import { FormImageComponent } from 'src/features/generalForms/builder/types/Image';

export const ImageBlock: FormImageComponent = () => {
  return <></>;
};
